__turbopack_context__.v({
  "placeholderTitle": "_2Jlula_placeholderTitle",
  "searchInput": "_2Jlula_searchInput",
  "titleEnter": "_2Jlula_titleEnter",
  "titleEnterFromTop": "_2Jlula_titleEnterFromTop",
  "titleExit": "_2Jlula_titleExit",
  "titleExitToBottom": "_2Jlula_titleExitToBottom",
});
